import { useState } from "react";
import { Button } from "../../../../components/ui";
import { CheckBox } from "../../../../components/ui/inputs";
import Turnstile from "react-turnstile";
import localization from "../../../../config/localization";
import userDeviceStore from "../../../../store/device.store";
import { DeviceType } from "../../../../models/constants/deviceType";

interface OneClickSignupConfirmationProps {
  turnstileSiteKey: string;
  onChangeMethod?: () => void | null;
  onContinue: (captchaToken: string) => any | null;
}

export function OneClickSignup({
  turnstileSiteKey,
  onChangeMethod,
  onContinue,
}: OneClickSignupConfirmationProps) {
  const [isAdult, setIsAdult] = useState(false);
  const [agreed, setAgreed] = useState(false);

  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const deviceType = userDeviceStore((state) => state.deviceType);
  const canContinue = isAdult && agreed && captchaToken;

  return (
    <div>
      <div className="flex items-center justify-between mb-6 rounded-3xl bg-[#1B1B1B] p-2">
        <div className="flex items-center gap-2">
          <img src={"/icons/ic-oneclick.svg"} alt="One Click" />
          <span className="text-white font-bold">{localization.oneclick}</span>
        </div>
        <div className="bg-black rounded-3xl shadow p-1">
          <Button
            className="px-3 py-1  font-medium text-gray-200 rounded-xl hover:bg-gray-800 transition"
            onClick={onChangeMethod}
          >
            {localization.change_method}
          </Button>
        </div>
      </div>

      <div className="mb-10">
        <div className="flex items-center gap-2 mb-4">
          <div>
            <img src={"/icons/ic-oneclick-2.svg"} alt="Info" className="p-2" />
          </div>
          <div className="text-white font-semibold text-xl mt-1">
            {localization.please_confirm_this_below_instructions}
          </div>
        </div>
      </div>

      <div className="space-y-3 mb-6">
        <CheckBox
          label={localization.over_eighteen_years_old}
          checked={isAdult}
          onChange={() => setIsAdult((v) => !v)}
        />
        <CheckBox
          label={localization.i_agree_with_terms_and_conditions}
          checked={agreed}
          onChange={() => setAgreed((v) => !v)}
        />
      </div>

      <div>
        <div className={deviceType === DeviceType.Mobile ? "flex justify-center" : undefined}>
          <Turnstile
            sitekey={turnstileSiteKey}
            theme="dark"
            onVerify={(token) => setCaptchaToken(token)}
            onExpire={() => setCaptchaToken(null)}
          />
        </div>
      </div>

      <div>
        <Button
          className={`mt-2 w-full  py-4 rounded-md ${isAdult && agreed && "bg-primary-gradient"
            } text-white font-bold  shadow hover:opacity-90 disabled:bg-gray-500 disabled:opacity-60`}
          disabled={!canContinue}
          onClick={() => captchaToken && onContinue(captchaToken)}
        >
          <span className="uppercase">{localization.continue}</span>
        </Button>
      </div>
    </div>
  );
}
